import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_ASSESSMENT,
  GET_ASSESSMENTS,
  ADD_ASSESSMENT,
  UPDATE_ASSESSMENT,
  DELETE_ASSESSMENT
} from '@/queries/modules/common-data/assessment';

export async function getAssessments(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ASSESSMENTS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setAssessments', data.getAssessments);
      context.commit('setSuccess', null);
      return data.getAssessments
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ASSESSMENT,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setAssessment', data.getAssessment);
      context.commit('setSuccess', null);
      return data.getAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_ASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const assessments = [...context.state.assessments];
      assessments.push(data.addAssessment);
      context.commit('setAssessments', assessments);
      context.commit('setSuccess', newItemSuccess(data.addAssessment.nameLocal));

      return data.addAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.assessments.findIndex(item => item.id === data.updateAssessment.id);
      const assessments = [
        ...context.state.assessments.slice(0, index),
        data.updateAssessment,
        ...context.state.assessments.slice(index + 1)
      ];
      context.commit('setAssessments', assessments);
      context.commit('setSuccess', updateItemSuccess(data.updateAssessment.nameLocal));

      return data.updateAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.assessments.findIndex(item => item.id === data.deleteAssessment.id);
      const assessments = [
        ...context.state.assessments.slice(0, index),
        ...context.state.assessments.slice(index + 1)
      ];
      context.commit('setAssessments', assessments);
      context.commit('setSuccess', deleteItemSuccess(data.deleteAssessment.nameLocal));

      return data.deleteAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

